import "./Login.scss";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import jwtDecode from "jwt-decode";
import axios from "axios";
import ConfirmModal from "../../components/ConfirmModal";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

function Committee() {
  const [userid, setUserId] = useState("");
  const [userpwd, setUserPwd] = useState("");
  const [checkPwdMsg, setCheckPwdMsg] = useState("");
  const [checkIdMsg, setCheckIdMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);

  // 로그인 이벤트 핸들러
  const onChangeId = ({ target: { value } }) => {
    setCheckIdMsg("");
    setUserId(value);
  };
  const onChangePwd = ({ target: { value } }) => {
    setCheckPwdMsg("");
    setUserPwd(value);
  };
  const [passwordType, setPasswordType] = useState({
    type: "password",
    visible: false,
  });
  const handlePasswordType = (e) => {
    setPasswordType(() => {
      if (!passwordType.visible) {
        return { type: "text", visible: true };
      }
      return { type: "password", visible: false };
    });
  };

  // 모달 핸들러
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setLoginFailed(false);
  };

  // 제출
  const handleSubmit = async (e) => {
    e.preventDefault();
    await LoginOK();
  };

  const LoginOK = async () => {
    await axios
      .post("/api/committee-member-login", null, {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        params: { id: userid, password: userpwd },
      })
      .then((response) => {
        window.sessionStorage.setItem("token", response.data.jwt);
      })
      // navigate("/");
      // alert("로그인 성공");
      .catch((error) => {
        console.log(error);
      });

    const isLogin = window.sessionStorage.getItem("token");
    //  console.log(`isLogin = ${isLogin}`)
    if (isLogin !== null) {
      // console.log(JSON.stringify(jwtDecode(isLogin)));
      let jwtdec = jwtDecode(isLogin);
      if (jwtdec.obj.state.toUpperCase() === "APPLIED") {
        window.sessionStorage.setItem("applied", true);
      } else {
        window.sessionStorage.setItem("applied", false);
      }
      if (jwtdec.obj.memberType.toUpperCase() === "COMMITTEE") {
        window.sessionStorage.setItem("committee", true);
      } else {
        window.sessionStorage.setItem("committee", false);
      }
      // alert("로그인 성공");
      window.location.replace("/");
    } else {
      window.sessionStorage.clear();
      // setLoginFailed(true);
      // alert("로그인에 실패 하였습니다. 로그인 정보를 다시 확인 하십시오.");
    }
  };

  // 아이디 비밀번호 찾기
  let [finder, setFinder] = useState("findId");
  let content = null;
  if (finder === "findPw") {
    content = <FindPw />;
  } else if (finder === "findId") {
    content = <FindId />;
  }

  const heighL = useRef();
  const btnWidth = useRef();

  function sliding() {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
    heighL.current.style.left = btnWidth.current.offsetWidth + "px";
  }
  function sliding2() {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
    heighL.current.style.left = 0 + "px";
  }
  function delBtnBg() {
    let delbtnBg = document.querySelector(".btns button:nth-child(1)");
    delbtnBg.style.background = "transparent";
  }

  return (
    <>
      {showModal ? (
        <div className="popup_bg" onClick={closeModal}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <div className="pophead">
              아이디/비밀번호 찾기
              <span onClick={closeModal}>
                <MdClose />
              </span>
            </div>

            <div className="btns">
              <button
                ref={btnWidth}
                onClick={() => {
                  setFinder("findId");
                  sliding2();
                  delBtnBg();
                }}
              >
                아이디 찾기
              </button>
              <button
                ref={btnWidth}
                onClick={() => {
                  setFinder("findPw");
                  sliding();
                  delBtnBg();
                }}
              >
                비밀번호 찾기
              </button>
              <span ref={heighL} className="hL"></span>
            </div>
            {content}
          </div>
        </div>
      ) : null}

      {loginFailed ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"로그인 실패"}
          content={`로그인 정보를 다시 확인 하십시오.`}
        />
      ) : null}

      <div className="contain login_contain">
        <div className="login_wrap login_wrap2">
          {/* <h1>위원회 로그인</h1> */}
          <form onSubmit={handleSubmit}>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="ID"
                name="userid"
                onChange={onChangeId}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="password"
                placeholder="Password"
                name="userpwd"
                onChange={onChangePwd}
              />
            </div>
            <div className="input_wrap">
              <button type="submit" className="btn_color">
                위원회 로그인
              </button>
            </div>
          </form>

          <div className="find">
            <p>
              계정이 없으신가요?
              <Link to="/committeesignup">회원가입</Link>
            </p>
            <p>
              아이디, 비밀번호를 찾으시겠습니까?
              <span onClick={openModal}>ID·PW찾기</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function FindId() {
  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const userName = watch("userName", "");
  const userEmail = watch("userEmail", "");

  const onSubmitFindId = async () => {
    try {
      await axios.get(`/api/committee-member-find-id`, {
        params: {
          email: userEmail,
          name: userName,
        },
      });
      Swal.fire("완료", "이메일을 확인해 주세요.", "success");
    } catch (error) {
      if (error.response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "입력하신 정보를 확인해 주세요.",
        });
      }
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitFindId)}>
      <div className="input_bg">
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="실무자명을 입력해 주세요."
            {...register("userName", {
              required: "* 실무자명은 필수 입력입니다.",
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userName && <p>{errors.userName?.message}</p>}
        </div>
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="이메일을 입력해 주세요."
            {...register("userEmail", {
              required: "* 이메일은 필수 입력입니다.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "* 이메일 형식을 확인하세요.",
              },
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userEmail && <p>{errors.userEmail?.message}</p>}
        </div>
        {userName.length === 0 ||
        userEmail.length === 0 ||
        errors.userEmail ||
        errors.userName ? (
          <button className="btn_none">아이디찾기</button>
        ) : (
          <button className="btn_color">아이디찾기</button>
        )}
      </div>
    </form>
  );
}

function FindPw() {
  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const userId = watch("userId", "");
  const userEmail = watch("userEmail", "");

  const onSubmitFindPwd = async () => {
    try {
      await axios.get("/api/committee-member-find-pw", {
        params: {
          id: userId,
          email: userEmail,
        },
      });
      Swal.fire("완료", "이메일을 확인해 주세요.", "success");
    } catch (error) {
      if (error.response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "입력하신 정보를 확인해 주세요.",
        });
      }
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitFindPwd)}>
      <div className="input_bg">
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="아이디를 입력해 주세요."
            {...register("userId", {
              required: "* 아이디는 필수 입력입니다.",
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userId && <p>{errors.userId?.message}</p>}
        </div>
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="이메일을 입력해 주세요."
            {...register("userEmail", {
              required: "* 이메일은 필수 입력입니다.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "* 이메일 형식을 확인하세요.",
              },
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userEmail && <p>{errors.userEmail?.message}</p>}
        </div>
        {userId.length === 0 ||
        userEmail.length === 0 ||
        errors.userEmail ||
        errors.userId ? (
          <button className="btn_none">비밀번호찾기</button>
        ) : (
          <button className="btn_color">비밀번호찾기</button>
        )}
      </div>
    </form>
  );
}
export default Committee;
